import { GroupOrderChef } from './dateMenus'
import { Subsidy } from './clientSettings'
import { MenuItemModVerb, MenuItemMod } from './menuItemMods'

export type ChosenMenuItemModGroup = {
  id: string
  isRequired: boolean
  isSingleOpt: boolean
  name: string
  verb: MenuItemModVerb
  chosenMods: MenuItemMod[]
}

export type OrderItem = {
  id: string
  name: string
  menuItemId: string
  quantity: number
  price: string
  chosenModGroups: ChosenMenuItemModGroup[]
}

export type SuborderMenu = {
  chefId: string
  cutoffTime: string
  menuId: string
  menuName: string
  orderItems: OrderItem[]
}

export enum SuborderStatus {
  ACTIVE = 'Active',
  CANCELLED = 'Cancelled',
}

export type Suborder = {
  id: string
  customer: Customer
  orderNumber: string
  status: SuborderStatus
  menus: SuborderMenu[]

  // Stored as Decimal Values in Backend
  // JSON Marshall converts them in strings
  subtotal: string
  tax: string
  tip: string
  total: string
  clientAmount: string
  walletAmount: string
}

export type Customer = {
  id: string
  firstName: string
  lastName: string
  email: string
}

export type GroupOrder = {
  id: string
  chefs: GroupOrderChef[]
  dateMenusId: string
  date: string
  subsidySettings: Subsidy | null
  orders: Suborder[]
  number: string
}

export type GroupOrderCustomServiceFeeSettings = {
  serviceFees: GroupOrderCustomServiceFee[]
}

export type GroupOrderCustomServiceFee = {
  serviceFeeType: 'Service' | 'Delivery' | 'Processing'
  feeDescription: string
  valueCalculationType: 'Flat Price' | 'Percent of Subtotal'
  value: number | null
  percentValue: number | null
  isTaxExempt: boolean
  itemTaxCode: string | null
}

export type CancelGroupOrderResponse = {
  accountingSyncError: string | null
  chefPayoutSyncError: string | null
  dateMenusUpdated: boolean
  groupOrderUpdated: boolean
  routeUpdated: boolean
  routingEmailSentError: string | null
  missingOpsEmailDistro: boolean
  chefEmailErrorMap: Record<string, string | null> // map of email to error string or null
  chefPayoutErrorMap: Record<string, string | null> // map of email to error string or null
}

export type AllSubOrderCancellationResponse = {
  allOrdersCancelled: boolean
  commitError: string | null
  emailError: string | null
  cancelledSubOrders: SubOrderCancellation[]
}

export type SubOrderCancellation = {
  subOrderId: string
  orderNumber: string
  userName: string
  userEmail: string

  neededRefund: boolean
  refundSucceeded: boolean
  refundError: string | null
}
